import React from 'react';
import PropTypes from 'prop-types';

import { METRICS_COMPONENT_TYPE } from 'configs/dashboardMetrices';
import BenchmarkConfig from '../BenchMarkConfig';

const { NUMBER } = METRICS_COMPONENT_TYPE;

const BenchmarkMetrices = ({ benchmark, handleConfigDataChange, handleBenchMarkChanged, goalError }) => {
  const { name: metricName, items } = NUMBER.configOptions.benchmark;

  return (
    <div>
      <div className="mb-3">
        Set the benchmark for this metric
      </div>
      <div>
        <BenchmarkConfig
          tabs={items}
          goalError={goalError}
          metricName={metricName}
          handleBenchMarkChanged={handleBenchMarkChanged}
          benchmark={benchmark}
          handleConfigDataChange={handleConfigDataChange}
        />
      </div>
    </div>
  );
}

BenchmarkMetrices.propTypes = {
  benchmark: PropTypes.shape({
    value: PropTypes.string
  }),
  handleConfigDataChange: PropTypes.func.isRequired,
  handleBenchMarkChanged: PropTypes.func.isRequired,
  goalError: PropTypes.string
};

BenchmarkMetrices.defaultProps = {
  goalError: undefined
};

export default BenchmarkMetrices;



// WEBPACK FOOTER //
// ./src/components/dashboard/metrics-list/BenchmarkMetrics.js